import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { ProductCostLogApi, ProductCostLogDataType } from "@/api/ProductCostLogApi";
import { Col, Container, Row } from "reactstrap";
import { formatDate } from "@utils/Api";
import LoadingScreen from "@components/content/LoadingScreen";
import { ProductApi, ProductDataType } from "@/api/ProductsApi";
import { ProviderApi } from "@/api/ProviderApi";
import { toNumberFormat } from "@utils/Utils";

const ProductCostLogIndex = () => {
  const params = useParams();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { id: productId } = params;
  const [product, setProduct] = useState<ProductDataType>({})
  const [providers, setProviders] = useState<Record<string, string>>({})
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (productId) {
      const run = async (productId: string) => {
        try {
          const product = await ProductApi.get(productId);
          const providers = await ProviderApi.optionsList();

          setProduct(product);
          setProviders(providers);
        } finally {
          setIsLoading(false)
        }
      }
      run(productId);
      setIsLoading(true)
    }
  }, [productId]);


  const getProviderName = (providerId?: string) => {
    if (providerId && providers.hasOwnProperty(providerId)) {
      return providers[providerId];
    }
    return "N/A"
  }

  const getUserAttribute = (costEntry: ProductCostLogDataType) => {
    return costEntry.user || costEntry.userEmail || "N/A"
  }

  return (
    <PageContainer
      title="Movimientos de Costo Producto"
      backUrl="/user/products"
    >
      <Container fluid>
        <Row>
          <Col xs="2" md="2">
            <h5><b>Product:</b></h5>
          </Col>
          <Col>
            <h5><b>{product?.codigo}</b></h5>
          </Col>
        </Row>
        <Row>
          <Col xs="2" md="2">
            <b>Costo Acutal:</b>
          </Col>
          <Col>
            {product?.costo}
          </Col>
        </Row>
        <Row>
          <Col xs="2" md="2">
            <b>Descripcion:</b>
          </Col>
          <Col>
            {product?.descripcion_fact}
          </Col>
        </Row>
        <hr />
      </Container>
      <ModelIndex<ProductCostLogDataType>
        mandatoryFilters={[{ productId: { eq: productId } }]}
        messages={{
          noResults: "No hay Registro de costo sobre este producto"
        }}
        ref={modelRef}
        fetchData={() => ProductCostLogApi.getCostMovementByProduct(`${productId}`)}
        secondaryProperties={[
          {
            key: (data) => {
              return formatDate(data.createdAt)
            },
            title: "Fecha",
          },
          {
            key: (item) => getProviderName(item.providerId || ""),
            title: "Provedor",
          },
          {
            key: (item) => getUserAttribute(item),
            title: "Usuario",
          },
          {
            key: (item) => toNumberFormat(item.cost || 0),
            title: "Costo",
            highlighted: true
          },
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "3" },
            { sm: "4", md: "3" },
            { sm: "4", md: "3" },
            { sm: "4", md: "3" },
          ]
        }
      >
      </ModelIndex>
      <LoadingScreen isLoading={isLoading} />
    </PageContainer >
  );
}

export default ProductCostLogIndex;
